import { render, staticRenderFns } from "./registrationLogin.vue?vue&type=template&id=95752758&scoped=true&"
import script from "./registrationLogin.vue?vue&type=script&lang=js&"
export * from "./registrationLogin.vue?vue&type=script&lang=js&"
import style0 from "./registrationLogin.vue?vue&type=style&index=0&id=95752758&prod&lang=scss&scoped=true&"
import style1 from "./registrationLogin.vue?vue&type=style&index=1&id=95752758&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95752758",
  null
  
)

export default component.exports